module.exports = __webpack_public_path__ + "img/img-5.9d5d9b30.webp";